/* global axios */

export const trackClientLocation = ({ accountId, location = {} }) =>
  axios.post('/api/v1/client_locations', {
    account_id: accountId,
    location,
  });
